import { AccessTime, AttachMoney, Percent, SvgIconComponent } from '@mui/icons-material';

export type HedgePlanTriggerKind = 'Value' | 'Budget' | 'Time';

export const HEDGE_PLAN_TRIGGER_KINDS: HedgePlanTriggerKind[] = ['Value', 'Budget', 'Time'];

export function readHedgePlanColor(variableName: string): string {
  return getComputedStyle(document.body).getPropertyValue(variableName).trim();
}

export const HEDGE_KIND_COLOR_VARIABLES: Record<HedgePlanTriggerKind, { line: string; label: string }> = {
  Value: { line: '--hedge-plan-value-hedge-line', label: 'Value executions' },
  Budget: { line: '--hedge-plan-budget-hedge-line', label: 'Budget executions' },
  Time: { line: '--hedge-plan-time-hedge-line', label: 'Time executions' },
};

export const HEDGE_KIND_ICONS: Record<HedgePlanTriggerKind, SvgIconComponent> = {
  Value: Percent,
  Budget: AttachMoney,
  Time: AccessTime,
};